export default __webpack_public_path__ + "static/media/sima.2de882b2.jpg";